module.exports = __webpack_public_path__ + "static/media/setting.29fef82d.svg";